import {useTranslation} from "next-i18next"
import React, {useContext} from "react"
import Typography from "../reusable/Typography/Typography"
import DataContext from "../../context/DataContext"
import Button from "../reusable/components/Button"
import {colors} from "../../colors/Colors"
import {ModalContext} from "../../context/ModalContext"

type Props = {
    categories: any[]
    isMobile: boolean
}
function HpCategoryStyles({categories, isMobile}: Props) {
	const {t} = useTranslation()
	const {activeHpLifestyleCategories: activeCategories, setActiveHpLifestyleCategories: setActiveCategories} = useContext(DataContext)
	const {closeModal} = useContext(ModalContext)
	return (
		<div style={{minWidth: isMobile ? "none" : "26rem", maxHeight: "95dvh", overflowY: "auto"}}
			className="p-4">
			<div style={{gap: "8px"}}
				className="d-flex align-items-start  justify-content-start flex-column">
				<Typography variant="bodySmBlack"
					style={{fontSize: "28px", lineHeight: "36px", marginBottom: "16px"}}>{t("select-lifestyle")}</Typography>
				<div
					onClick={() => setActiveCategories(prev => activeCategories.includes(123) ? prev?.filter(item => item !== 123) : [123])}
					style={{borderRadius: "4px", border: "1.5px solid #DEE2E6", height: "48px", padding: "16px 12px"}}
					className={`col-12 lifestyle-btn cursor-pointer  d-flex align-items-center justify-content-start ${activeCategories.includes(123) ? "active" : ""}`}>
					<Typography variant="bodySm">{t("idk-where-to-start-label")}</Typography>
				</div>
				{categories?.map((category, index) => {
					const isActive = activeCategories.includes(index)
					return <div key={index}
						onClick={() => setActiveCategories(prev => isActive ? prev?.filter(item => item !== index) : [...(prev || [])?.filter(idx => idx !== 123), index])}
						style={{borderRadius: "4px", border: "1.5px solid #DEE2E6", height: "48px", padding: "16px 12px"}}
						className={`col-12 lifestyle-btn cursor-pointer  d-flex align-items-center justify-content-start ${isActive ? "active" : ""}`}>
						<Typography variant="bodySm">{ category?.title}</Typography>
					</div>
				})}
				<Button label={t("confirm")}
					onClick={() => closeModal()}
					className="col-12"
					color="black"
					fontSizeSmall
					bgColor={colors.primary} />
			</div>
		</div>
	)
}

export default HpCategoryStyles
